/**
 * AlertsByLevel.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { orderBy, isEqual } from 'lodash';

import SingleAlert from './SingleAlert';
import MultiAlert from './MultiAlert';

import * as Icons from '../../sharedComponents/icons/Icons';
import * as alertLevels from '../../../helpers/alertLevelsHelper';

const propTypes = {
    alerts: PropTypes.array.isRequired,
    level: PropTypes.string.isRequired
};

const defaultProps = {};

export default class AlertsByLevel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: true,
            sortedAlerts: orderBy(this.props.alerts, ["created_at"], ["desc"])
        };

        this.setAlerts = this.setAlerts.bind(this);
        this.close = this.close.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // We only want to rerender if `alerts` or `level` props change,
        // or if we change the open/closed state
        return (
            !isEqual(nextProps.alerts, this.props.alerts)
            || nextProps.level !== this.props.level
            || nextState.open !== this.state.open
        );
    }

    componentWillReceiveProps(nextProps) {
        this.setAlerts(nextProps.alerts);
    }

    setAlerts(alerts) {
        this.setState({
            sortedAlerts: orderBy(alerts, ["created_at"], ["desc"])
        });
    }

    close() {
        this.setState({
            open: false
        });
    }

    stylesForLevel(level) {
        switch (level) {
            case alertLevels.SUCCESS_ALERT_LEVEL:
                return {
                    className: 'rec-success-full-banner',
                    icon: (<Icons.IconInfo className="rec-icon-info" />),
                    title: 'Success:',
                    inlineTitle: 'notifications'
                };
            case alertLevels.ERROR_ALERT_LEVEL:
                return {
                    className: 'rec-error-full-banner',
                    icon: (<Icons.IconInfo className="rec-icon-info" />),
                    title: 'Error:',
                    inlineTitle: 'errors'
                };
            case alertLevels.INFO_ALERT_LEVEL:
                return {
                    className: 'rec-info-full-banner',
                    icon: (<Icons.IconInfo className="rec-icon-info" />),
                    title: 'Info:',
                    inlineTitle: 'notifications'
                };
            case alertLevels.WARNING_ALERT_LEVEL:
            default:
                return {
                    className: 'rec-warning-full-banner',
                    icon: (<Icons.IconWarning className="rec-icon-warning" />),
                    title: 'Alert:',
                    inlineTitle: 'alerts'
                };
        }
    }

    render() {
        // TYPE OF ERROR
        const levelStyles = this.stylesForLevel(this.props.level);

        if (!this.state.open || !this.props.alerts || this.props.alerts.length === 0) {
            return null;
        }

        // LAYOUT IF ONE NOTIFICATION EXISTS & IT IS LESS THAN 350 CHARACTERS
        if (this.state.sortedAlerts.length === 1 && this.state.sortedAlerts[0].body.length <= 350) {
            return (
                <SingleAlert
                    alertClassName={levelStyles.className}
                    alertIcon={levelStyles.icon}
                    alertTitle={levelStyles.title}
                    alert={this.state.sortedAlerts[0]}
                    closeAlert={this.close} />
            );
        }

        // LAYOUT IF TWO OR MORE NOTIFICATIONS EXISTS
        return (
            <MultiAlert
                alertClassName={levelStyles.className}
                alertIcon={levelStyles.icon}
                alertTitle={levelStyles.title}
                alerts={this.state.sortedAlerts}
                closeAlert={this.close} />
        );
    }
}


AlertsByLevel.propTypes = propTypes;
AlertsByLevel.defaultProps = defaultProps;
